import { AuthCallbackController } from './auth-callback-controller';
import { EntityTermsAndConditionsController } from './entity-terms-and-conditions-controller';
import { FlexDocumentController } from './flex-document-controller';
import { NotFoundController } from './not-found-controller';
import { ErrorController } from './error-controller';
import { HomeController } from './home-controller';
import { SignInController } from './sign-in-controller';
import { SignoutController } from './signout-controller';
import { SignUpController } from './signup-controller';
import { ZendeskLoginController } from './zendesk/login-controller';
import { ZendeskLogoutController } from './zendesk/logout-controller';
import { ZendeskSsoController } from './zendesk/sso-controller';
import { CommercialTermsController } from './commercial-terms-controller';
import { AboutYourApplicationController } from './about-your-application-controller';
import { UserProfileController } from './user-profile-controller';
import { ForcePzController } from './force-pz-controller';
import { UnsubscribeController } from './unsubscribe-controller';

import wrapWithAccountDataController from 'controllers/wrap-with-account-data-controller';

export const controllers = [
  AuthCallbackController,
  wrapWithAccountDataController(EntityTermsAndConditionsController),
  wrapWithAccountDataController(FlexDocumentController),
  wrapWithAccountDataController(HomeController),
  SignInController,
  SignoutController,
  SignUpController,
  ZendeskLoginController,
  ZendeskLogoutController,
  ZendeskSsoController,
  ErrorController,
  CommercialTermsController,
  AboutYourApplicationController,
  wrapWithAccountDataController(UserProfileController),
  wrapWithAccountDataController(ForcePzController),
  UnsubscribeController,
  // 404 error needs to come last as its a catch all route
  wrapWithAccountDataController(NotFoundController),
];
